import { useDioxus } from '@/lib/wasm'

export const LoadingSettings = () => {
  const ref = useDioxus('mount_loading_settings')
  return <div ref={ref} className="contents" />
}
